import { AuthenHttpService } from "./authen";
import { DashboardHttpService } from "./dashboard";
import { EvaluationFormHttpService } from "./evaluation_form";
import { EvaluatorHttpService } from "./evaluator";
import { EvaluatorHistoryHttpService } from "./evaluator_history";
import { LocationHttpService } from "./location";
import { ReportHttpService } from "./report";
import { SatHttpService } from "./sat";
import { UserHttpService } from "./user";

const authenHttpService = new AuthenHttpService();
const satHttpService = new SatHttpService();
const userHttpService = new UserHttpService();
const evaluationFormHttpService = new EvaluationFormHttpService();
const evaluatorHttpService = new EvaluatorHttpService();
const evaluatorHistoryHttpService = new EvaluatorHistoryHttpService();
const dashboardHttpService = new DashboardHttpService();
const locationHttpService = new LocationHttpService();
const reportHttpService = new ReportHttpService();

const CoreAPI = {
    authenHttpService,
    satHttpService,
    userHttpService,
    evaluationFormHttpService,
    evaluatorHttpService,
    evaluatorHistoryHttpService,
    dashboardHttpService,
    locationHttpService,
    reportHttpService,
}

export default CoreAPI;
